package com.shadowings.gero.data.lessons.placeholders
import com.shadowings.gero.data.lessons.buildVocabQuizContent
import com.shadowings.gero.data.lessons.chapter5.getVocabVerbs1Content
import com.shadowings.gero.data.lessons.chapter5.getVocabVerbs2Content


import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word

fun getVocabVerbsContent(words: List<Word>, languageCode: String): List<IExplanation> {
    return getVocabVerbs1Content(words, languageCode) + getVocabVerbs2Content(words, languageCode)
}

fun getVocabVerbsQuizContent(
    explanations: List<IExplanation>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    return buildVocabQuizContent(explanations, words, languageCode)
}
